export default __webpack_public_path__ + "static/media/step-1.3fb10baf.png";